import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useProtectedFileUrl } from '../../utils/protectedFiles';
import './UserProfileButton.css';

const UserProfileButton = () => {
    const navigate = useNavigate();
    const { user } = useAuth();
    const [profilePhoto, setProfilePhoto] = useState(user?.profilePhoto);
    const [imageError, setImageError] = useState(false);
    const { objectUrl: profilePhotoUrl, error: profilePhotoError } = useProtectedFileUrl(profilePhoto);

    // Update local state when user context changes
    useEffect(() => {
        if (user?.profilePhoto !== profilePhoto) {
            setProfilePhoto(user?.profilePhoto);
            setImageError(false);
        }
    }, [user?.profilePhoto, profilePhoto]);

    const handleImageError = () => {
        console.error('Failed to load profile photo:', profilePhoto);
        setImageError(true);
    };

    const showPlaceholder = !profilePhoto || imageError || profilePhotoError || !profilePhotoUrl;

    return (
        <button 
            className="user-profile-button" 
            onClick={() => navigate('/profile')}
            title="View Profile"
        >
            {!showPlaceholder && (
                <img 
                    src={profilePhotoUrl} 
                    alt="Profile" 
                    className="profile-button-photo"
                    onError={handleImageError}
                    key={profilePhoto} // Force re-render when photo URL changes
                />
            )}
            {showPlaceholder && (
                <div className="profile-button-placeholder">
                    {user?.fullName?.charAt(0).toUpperCase() || user?.username?.charAt(0).toUpperCase() || 'U'}
                </div>
            )}
            <span className="profile-button-name">{user?.fullName || user?.username || 'Profile'}</span>
        </button>
    );
};

export default UserProfileButton;
